import { APIStatus, LanguageConfig } from '../config/CustomEnums';
import {
  getAppUpdate,
  updateAppUpdate,
} from '../services/AppUpdateAPIHelper';
import { loading } from './LoadingUtil';

const getInitialState = () => ({
  appUpdateDetail: {},
  loadingStatus: APIStatus.none,
  formHasSubmitted: false,
  hasUpdatedDefaultValues: false,
});

const parseTranslations = (data) => {
  if (!data.translations) {
    return {};
  };
  const translation = {};
  translation[LanguageConfig.english] = {
    forceUpdateTitle: data.forceUpdateTitle,
    forceUpdateDescription: data.forceUpdateDescription,
    optionalUpdateTitle: data.optionalUpdateTitle,
    optionalUpdateDescription: data.optionalUpdateDescription,
  };
  data.translations.forEach((item) => {
    const language = item.language;
    translation[language] = {
      language,
      forceUpdateTitle: item.forceUpdateTitle,
      forceUpdateDescription: item.forceUpdateDescription,
      optionalUpdateTitle: item.optionalUpdateTitle,
      optionalUpdateDescription: item.optionalUpdateDescription,
    };
  });
  return translation;
};

const parseAppUpdate = (data) => {
  return {
    iosLowestSupportingVersion: data.iosLowestSupportingVersion,
    androidLowestSupportingVersion: data.androidLowestSupportingVersion,
    translations: parseTranslations(data),
  };
};

const parseInputBody = (values) => {
  const translations = [];
  const translationArray = Object.keys(values.translations || {});
  translationArray.forEach((language) => {
    if (language === LanguageConfig.english) {
      return;
    }
    translations.push({
      ...values.translations[language],
      language: language,
    });
  });
  let inputBody = {
    iosLowestSupportingVersion: values.iosLowestSupportingVersion,
    androidLowestSupportingVersion: values.androidLowestSupportingVersion,
    forceUpdateTitle: values.translations?.[LanguageConfig.english]?.forceUpdateTitle,
    forceUpdateDescription: values.translations?.[LanguageConfig.english]?.forceUpdateDescription,
    optionalUpdateTitle: values.translations?.[LanguageConfig.english]?.optionalUpdateTitle,
    optionalUpdateDescription: values.translations?.[LanguageConfig.english]?.optionalUpdateDescription,
    translations: translations,
  };
  return inputBody;
};

export default {
  namespace: 'appUpdate',
  state: getInitialState(),
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    resetStatus(state, { payload }) {
      return {
        ...state,
        formHasSubmitted: false,
        hasUpdatedDefaultValues: false,
      }
    },
  },
  effects: {
    getAppUpdate: [
      function* ({ payload }, { put }) {
        yield put({
          type: 'updateState',
          payload: {
            loadingStatus: APIStatus.calling,
          },
        });
        const serviceArgs = [getAppUpdate];

        function* onSuccess(data) {
          const appUpdateData = data.appUpdate || {};
          const appUpdateDetail = parseAppUpdate(appUpdateData);
          yield put({
            type: 'updateState',
            payload: {
              appUpdateDetail: appUpdateDetail,
              loadingStatus: APIStatus.success,
              hasUpdatedDefaultValues: true,
            },
          });
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    updateAppUpdate: [
      function* ({ payload }, { select, put }) {
        const values = payload.values;
        const inputBody = parseInputBody(values);
        const serviceArgs = [updateAppUpdate, inputBody];

        function* onSuccess() {
          yield put({
            type: 'updateState',
            payload: {
              formHasSubmitted: true,
            },
          });
          const afterActions = payload.afterActions || (() => { });
          yield afterActions();

          yield put({ type: 'getAppUpdate', payload: {} });
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
  },
};
